import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isActive)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["notification has-text-centered", [_ctx.isFadeOut ? 'fade-out' : '', _ctx.toast.type]])
      }, _toDisplayString(_ctx.toast.message), 3))
    : _createCommentVNode("", true)
}